/*
 * @Descripttion:
 * @Author: 老板说这个需求很简单
 * @Date: 2025-05-14 14:01:14
 * @LastEditTime: 2025-06-13 11:08:10
 * @LastEditors: sudo_rm_rf
 */

import { RouteRecordRaw, createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import { baseRouter } from './modules/base';
import { devTestRouter } from './modules/devTest';

let routes: RouteRecordRaw[] = [
  ...baseRouter,
  //  ...devTestRouter
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
